<template>
  <el-dialog
    v-model="data.visible"
    width="800px"
    append-to-body
    :show-close="false"
    :style="{ '--el-dialog-padding-primary': 0 }"
    @close="close"
  >
    <template #header>
      <div class="dialog-title">
        <div class="title">图标配置中心</div>
        <div class="close" @click="data.visible = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </template>
    <div class="dialog-content" v-loading="data.loading">
      <ul class="content-tab">
        <li class="tab">
          <div class="tab-item" v-for="tab in data.tabs" :key="tab.value">
            <span
              class="tab-item-title"
              :class="data.activeTab === tab.value ? 'active' : ''"
              @click="changeTab(tab)"
              >{{ tab.title }}</span
            >
            <span class="tab-item-active" v-if="data.activeTab === tab.value"></span>
          </div>
        </li>
        <li
          class="tab-color"
          v-show="data.activeTab === 'facet' || data.activeTab === 'iconly'"
        >
          <span class="tab-color-title">配色</span>
          <ul class="tab-color-content">
            <li
              class="tab-color-content-item"
              v-for="color in iconColor"
              :key="color"
              :style="{
                background: color === 'default' ? 'rgba(1, 25, 51, 1)' : color,
              }"
              @click="changeImgColor(color)"
            >
              <span
                class="iconfont icondagoufuzhi"
                v-if="color === data.config.color.value"
                >√</span
              >
            </li>
          </ul>
          <div class="tab-color-custom">
            <span class="custom-title">自定义配色</span>
            <div class="custom-color">
              <el-color-picker
                v-model="data.color"
                :style="{
                  background: data.color,
                }"
                @change="changeCustomColor"
              ></el-color-picker>
            </div>
          </div>
        </li>
      </ul>
      <div class="content-icon" v-if="data.activeTab !== 'svgicons'">
        <ul class="content-icon-left">
          <li
            class="left-title"
            v-for="(tab, index) in leftTab"
            :key="tab.value"
            :class="tab.value === data.activeLeftTab ? 'active' : ''"
            @click="scrollTo(tab, index)"
          >
            {{ tab.title
            }}{{ data.activeTab === "custom" ? `(${tab.list.length}/100)` : "" }}
          </li>
        </ul>
        <ul class="content-icon-right">
          <el-scrollbar ref="scrollRef">
            <el-upload
              class="upload-comp"
              drag
              :action="$imgurl + '/confile/upload?accesstoken=' + token"
              :on-success="uploadSuccess"
              :on-progress="uploadProgress"
              :before-upload="uploadBefore"
              :show-file-list="false"
              multiple
              v-if="data.activeTab === 'custom'"
            >
              <i class="WSiconfont WSicon-Plus1"></i>
              <div class="el-upload__text">
                点击拖拽导入多张{{ data.activeLeftTab === "icon" ? "图标" : "插画" }}
              </div>
            </el-upload>
            <li
              class="content-icon-right-item"
              v-for="tab in leftTab"
              :key="tab.value"
            >
              <icon-list
                ref="iconlist"
                v-show="!tab.noShow"
                :title="tab.title"
                :isUpload="handleIsUpload"
                v-model:loading="data.loading"
                :type="handleType"
                :list="tab.list"
                :isDefault="tab.isDefault"
                :color="data.config.color.value"
                :isColor="tab.isColor"
                :custom="data.activeTab === 'custom'"
                v-model:activeValue="data.config.img.url"
                @change="handleChangeValue"
                @del="delCustomImg"
                @isColor="data.config.isColor = $event"
              ></icon-list>
            </li>
          </el-scrollbar>
        </ul>
      </div>
      <div class="content-icon" v-else>
        <IconDesign
          ref="iconDesign"
          v-model:activeValue="data.config.img.url"
          :config="data.config.iconParkConfig"
          v-model:imgValue="data.config.img.base64Url"
        />
      </div>
    </div>
    <div class="dialog-footer">
      <div>
        <el-button @click="cancle">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'IconPart',
}
</script>

<script setup>
import { computed, getCurrentInstance, reactive, ref, defineEmits, defineExpose } from 'vue'
import IconList from './components/iconList.vue'
import IconDesign from './components/iconDesign.vue'
import { tabs, iconColor } from './config'
import { getrencenticons, deleteficon, getficonlist, addficon } from '@/port/common/icon.js'
import { cloneDeep } from 'lodash'
import { ElMessage } from 'element-plus'

const { proxy: $vm } = getCurrentInstance()

const emit = defineEmits(['confirm'])

defineExpose({
  open
})

const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''

const scrollRef = ref(null)
const iconlist = ref(null)
const iconDesign = ref(null)

const data = reactive({
	visible: false,
	tabs: cloneDeep(tabs),
	loading: false,
	activeTab: 'facet',
	activeLeftTab: 'facetBg',
	config: {
		type: 0, // 判断是物思的图标还是字节的 默认0是物思 1是字节
		color: {
			value: 'default',
			type: 'local'
		},
		img: {
			url: '',
			base64Url: '' // 字节图标地址
		},
		iconParkConfig: { // 字节图标的配置
			theme: 'outline',
			size: 24,
			color: {
				outline: '#333',
				filled: '#333',
				'two-tone': ['#333', '#2F88FF'],
				'multi-color': ['#333', '#2F88FF', '#FFF', '#43CCF8']
			},
			strokeWidth: 4,
			strokeLinecap: 'round', // 端点类型
			strokeLinejoin: 'round' // 拐点类型
		},
		isColor: false,
		activeTab: 'facet',
		activeLeftTab: 'facetBg'
	},
	color: '',
	isDefault: false,
})

const leftTab = computed(() => {
  const tab = data.tabs.find(item => item.value === data.activeTab)
  return tab.tabItem
})

const handleIsUpload = computed(() => {
	return data.activeTab === 'custom'
})

const handleType = computed(() => {
	if ((data.activeTab === 'custom' && data.activeLeftTab === 'book') || data.activeTab === 'illustration') {
		return 'illustration'
	} else {
		return 'iconly'
	}
})

async function getFacetIconUrl() {
	// 获取 面性的url
	data.tabs[0].tabItem.forEach(async item => {
		if (item.list.length === 0) {
			let name = item.value
			if (item.value === 'facetNoBg') {
				name = 'facet'
			} else if (item.value === 'facetBg') {
				name = 'facet-bg'
			} else {
				name = item.value
			}
			const urls = await getIcon(name)
			if (item.list.length === 0) {
				item.list = urls
				if ((data.config.img.url === '' || data.config.img.url === 'default') && !data.isDefault) {
					data.config.img.url = urls[0].url
				}
			}
		}
	})
}

// async function getIconly() {
// 	// 获取线性的url
// 	data.tabs[1].tabItem.forEach(async item => {
// 		const name = item.value
// 		if (item.list.length === 0) {
// 			const url = await getIcon(name)
// 			item.list = url
// 		}
// 	})
// }

function getIconlyOrIllustration(num) {
	// 获取插画的url
	data.tabs[num].tabItem.forEach(async item => {
		const name = item.value
		if (item.list.length === 0) {
			const url = await getIcon(name)
			item.list = url
		}
	})
}

async function getIcon(name) {
	data.loading = true
	const res = await getrencenticons({ name }).finally(() => {
		data.loading = false
	})
	if (res.code === 0) {
		const _data = res.data.map(item => {
			return {
				url: item
			}
		})
		return _data
	}
}

function uploadProgress() {

}

function uploadBefore(file) {
	const isJPG = file.type === 'image/jpg'
	const isPNG = file.type === 'image/png'
	const isGIF = file.type === 'image/gif'
	const isJPEG = file.type === 'image/jpeg'
	const isWEPB = file.type === 'image/webp'

	if (!isJPG && !isPNG && !isGIF && !isJPEG && !isWEPB) {
		/* Warn: Unknown source: $message */
		ElMessage.error('上传头像图片只能是 JPG或png或gif或jpeg 格式!')
	}
	const isLt2M = file.size / 1048576 < 5
	if (!isLt2M) {
		/* Warn: Unknown source: $message */
		ElMessage.error('上传图片大小不能超过 5MB!')
	}
	return (
		(isJPG && isLt2M) ||
		(isPNG && isLt2M) ||
		(isGIF && isLt2M) ||
		(isJPEG && isLt2M) ||
		(isWEPB && isLt2M)
	)
}

function uploadSuccess(file) {
	const url = `confiles/${file}`
	if (data.activeTab === 'custom' && data.activeLeftTab === 'icon') {
		// 图标上传
		addficon({
			type: 1,
			url
		}).then(res => {
			if (res.code === 0) {
				getCustomImg()
			}
		})
	} else {
		// 插画上传
		addficon({
			type: 2,
			url
		}).then(res => {
			if (res.code === 0) {
				getCustomImg()
			}
		})
	}
}

function open(config, isDefault = true) {
	/*
	 * config   当前配置信息  如果说不传的话，那就直接用默认的
	 *
	 * isDefault 是否需要默认的选项  默认是需要
	 *
	 */
	// 通过ref打开
	data.isDefault = isDefault
	if (config) {
		data.config = JSON.parse(JSON.stringify(config))
		// 由于这个需求后面加的 就要在这边判断下咯
		if (config.activeTab) {
			data.activeTab = config.activeTab
		}
		if (config.activeLeftTab) {
			data.activeLeftTab = config.activeLeftTab
		}
	}

	if (!isDefault) {
		data.tabs[0].tabItem[0].isDefault = false
	}

	if (config && config.color.type === 'custom') {
		data.color = config.color.value
  }
  // 赋值之后 请求数据
  getAllData(data.activeTab)
	data.visible = true
}

function getCustomImg() {
	// 请求图标的
	data.tabs.find(item => item.value === 'custom').tabItem.forEach(async (item) => {
		const { code, data } = await getficonlist({
			curpage: 1,
			pagesize: 100,
			type: item.type
		})
		if (code === 0) {
			item.list = data
		} else {
			/* Warn: Unknown source: $message */
			$vm.$message.error('请求图标失败')
		}
	})
}

function delCustomImg(val) {
	// 删除自定义上传的回调
	/* Warn: Unknown source: $confirm */
	$vm.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning'
	}).then(async () => {
		// 删除自定义上传的回调
		const { code, msg } = await deleteficon({
			ficonId: val.id
		})
		if (code === 0) {
			/* Warn: Unknown source: $message */
			$vm.$message.success(msg)
		} else {
			/* Warn: Unknown source: $message */
			$vm.$message.error(msg)
		}
		getCustomImg()
	})
}

function handleChangeValue(value, isBase) {
	// 列表点击单个图片回调的操作
	data.config.img.url = value
	if (isBase) {
		// 如果改变了颜色 转化为base64
		const div = document.createElement('div')
		div.innerHTML = value
		const svg = div.querySelector('svg')
		const svgBase64 = new XMLSerializer().serializeToString(svg)
		const ImgBase64 = `data:image/svg+xml;base64,${window.btoa(svgBase64)}`
		data.config.img.base64Url = ImgBase64
	}
}

function changeImgColor(color) {
	// 当选择本地颜色
	if (color !== 'default') {
		// data.loading = true
	}
	data.config.color.value = color
	data.config.color.type = 'local'
}

function changeCustomColor(color) {
	if (color === null) {
		data.config.color.value = 'default'
		data.config.color.type = 'local'
		return
	}
	// 选择自定义颜色
	data.config.color.value = color
	data.config.color.type = 'custom'
}

function close() {
	// 关闭弹窗
}

function scrollTo(tab, index) {
	// 点击左侧导航栏
	data.activeLeftTab = tab.value
	if (data.activeTab === 'custom') {
		if (data.activeLeftTab === 'icon') {
			// 点击的图标
			tab.noShow = false
			leftTab.value(data.activeTab)[index + 1].noShow = true
		} else {
			// 点击的插画
			tab.noShow = false
			leftTab.value(data.activeTab)[index - 1].noShow = true
		}
		return
	}
	const navContents = Array.from(document.getElementsByClassName('content-icon-right-item'))
	const offsetTopArr = []
	navContents.forEach((item) => {
		offsetTopArr.push(item.offsetTop)
	})
	const el = scrollRef.value.$el.childNodes[0]
	el.scrollTo({
		top: offsetTopArr[index],
		behavior: 'smooth'
	})
}

function resetCustomShow() {
	// 重置自定义上传
	data.tabs[data.tabs.length - 1].tabItem.forEach(item => {
		if (item.value === 'icon') {
			item.noShow = false
		} else {
			item.noShow = true
		}
	})
}

function changeTab(tab) {
	if (tab.value === 'custom') {
		// 重置下显示的
		resetCustomShow()
	}
	// 点击顶部导航栏
	data.activeTab = tab.value
	if (tab.tabItem) {
		data.activeLeftTab = tab.tabItem[0].value
	}
	getAllData(tab.value)
}

function getAllData(value) {
	switch (value) {
		case 'facet':
      setTimeout(() => {
        iconlist.value.forEach(item => {
          item.colorChange(data.config.color.value)
        })
			}, 300)
			getFacetIconUrl()
			break
		case 'iconly':
			setTimeout(() => {
				iconlist.value.forEach(item => {
					item.colorChange(data.config.color.value)
				})
			}, 300)
			getIconlyOrIllustration(1)
			break
		case 'illustration':
			getIconlyOrIllustration(3)
			break
		case 'custom':
			getCustomImg()
			break
	}
}

function cancle() {
	// 取消 关闭弹窗
	data.visible = false
}

function confirm() {
	// 确定保存
	console.log(data.config.img.url);
	data.visible = false
	data.config.type = data.config.img.url === '' ||
		data.config.img.url.includes('confiles') ||
		data.config.img.url.includes('userfiles') ||
		data.config.img.url.includes('svg') ||
		data.config.img.url.includes('default') ? 0 : 1
	data.config.isColor = !(data.config.img.url.includes('userfiles') || data.config.img.url.includes('default'))
	if (data.config.type === 1) {
		data.config.iconParkConfig = JSON.parse(JSON.stringify(iconDesign.value.iconConfig))
	} else {
		data.config.iconParkConfig = {
			theme: 'outline',
			size: 24,
			color: {
				outline: '#333',
				filled: '#333',
				'two-tone': ['#333', '#2F88FF'],
				'multi-color': ['#333', '#2F88FF', '#FFF', '#43CCF8']
			},
			strokeWidth: 4,
			strokeLinecap: 'round', // 端点类型
			strokeLinejoin: 'round' // 拐点类型
		}
	}
	// 每次确定的时候  将所选的tab放入config
	data.config.activeTab = data.activeTab
	data.config.activeLeftTab = data.activeLeftTab
	emit('confirm', data.config)
}
</script>
<style lang="scss" scoped>
.dialog-title {
  height: 48px;
  width: 100%;
  border-radius: 8px 8px, 0px, 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 0 24px;
  box-sizing: border-box;
  .title {
    font-weight: 600;
    line-height: 26px;
    color: rgba(1, 25, 51, 1);
    font-size: 18px;
  }
  .close {
    width: 24px;
    height: 24px;
    &:hover {
      i {
        color: #4e86ff;
      }
    }
    i {
      display: inline-block;
      transition: 0.3s;
      font-size: 24px;
      color: rgba(52, 71, 92, 1);
      cursor: pointer;
    }
  }
}
::v-deep .el-dialog__header {
  padding: 0;
  border-bottom: none;
}
::v-deep .el-dialog__body {
  padding: 0;
  height: 516px;
  box-sizing: border-box;
}

.dialog-content {
  height: 448px;
  background: rgba(250, 250, 251, 1);
  display: flex;
  flex-direction: column;
  .content-tab {
    display: flex;
    padding: 0 24px;
    height: 40px;
    background: #fff;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    .tab {
      display: flex;
      flex: 1;
      align-items: center;
      height: 100%;
      &-item {
        margin-right: 16px;
        cursor: pointer;
        position: relative;
        &-title {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          color: rgba(153, 163, 173, 1);
        }
        &-active {
          width: 14px;
          height: 2px;
          background: rgba(5, 126, 255, 1);
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 4px;
        }
        .active {
          color: rgba(1, 25, 51, 1);
        }
      }
    }
    .tab-color {
      width: 308px;
      border-left: 1px solid rgba(230, 232, 235, 1);
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding-left: 8px;
      &-title {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(153, 163, 173, 1);
        margin-right: 4px;
      }
      &-content {
        display: flex;
        &-item {
          width: 16px;
          height: 16px;
          margin-right: 4px;
          border-radius: 2px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          .icondagoufuzhi {
            font-size: 12px;
            color: #fff;
            transform: scale(0.5);
          }
        }
      }
      &-custom {
        display: flex;
        align-items: center;
        margin-left: 4px;
        .custom-title {
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          color: rgba(153, 163, 173, 1);
        }
        .custom-color {
          margin-left: 4px;
        }
      }
    }
  }
  .content-icon {
    padding: 24px 0 24px 24px;
    box-sizing: border-box;
    display: flex;
    flex: 1;
    height: 408px;
    &-left {
      border-right: solid 1px rgba(245, 246, 247, 1);
      width: 122px;
      height: 100%;
      box-sizing: border-box;
      .left-title {
        height: 32px;
        line-height: 32px;
        padding: 0 16px 0 8px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 163, 173, 1);
        cursor: pointer;
      }
      .active {
        background: rgba(245, 246, 247, 1);
        font-size: 14px;
        font-weight: 400;
        color: rgba(5, 126, 255, 1);
      }
    }
    &-right {
      padding-left: 16px;
      height: 100%;
      box-sizing: border-box;
      flex: 1;
      .upload-comp {
        margin-bottom: 16px;
        .el-upload {
          .el-upload-dragger {
            width: 268px;
            height: 130px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .iconfont {
              width: 24px;
              height: 24px;
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
      }
      .el-scrollbar {
        height: 100% !important;
      }
    }
  }
}
.dialog-footer {
  width: 100%;
  height: 68px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  justify-content: flex-end;
  box-sizing: border-box;
  .el-button {
    width: 72px;
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
  .el-button--primary {
    background-color: rgba(5, 126, 255, 1);
    border-color: rgba(5, 126, 255, 1);
  }
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

::v-deep .custom-color .el-color-picker {
  border-radius: 100%;
  width: 16px;
  height: 16px;
  border: solid 1px #fff;
  cursor: pointer;
  background: rgba(153, 153, 153, 0.31);
  box-shadow: 0px 0px 3px 0px rgba(153, 153, 153, 0.31);
  .el-color-picker__trigger {
    width: 18px;
    height: 12px;
    padding: 0;
    border: none;
    .el-color-picker__color {
      display: none;
    }
    .el-color-picker__icon {
      display: none !important;
    }
  }
}
</style>
